export default __webpack_public_path__ + "static/media/photo--sm--mike.4ece48d7.jpg";